import { render, staticRenderFns } from "./ShipmentsOptions.vue?vue&type=template&id=b1db3cda&scoped=true"
import script from "./ShipmentsOptions.vue?vue&type=script&lang=js"
export * from "./ShipmentsOptions.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsOptions.vue?vue&type=style&index=0&id=b1db3cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1db3cda",
  null
  
)

export default component.exports